import React, { useEffect, useRef } from "react";
import FormGroup from "../../../forms/FormGroup";
import LabeledBooleanCheckbox from "../../../forms/LabeledBooleanCheckbox";
import { useSchema } from "../../ContractContext";
import { useInputFocus } from "../../validation/InputValidationContext";
import { ContractFieldProps, useContractField } from "../ContractFieldInput";

export interface ContractCheckboxInputProps
  extends Omit<ContractFieldProps, "type" | "label"> {
  label?: string;
}

export default function ContractCheckboxField(
  props: ContractCheckboxInputProps
) {
  const { name, label, section, validation } = props;
  const id = `${section}.${name}`;
  const schema = useSchema();
  const { label: schemaLabel, description } = schema.getFieldType(
    section,
    name
  );
  const focus = useInputFocus(section, name);
  const field = useContractField<boolean>({
    type: "checkbox",
    section,
    name,
    validation,
  });

  useEffect(() => {
    if (focus) {
      if (inputRef?.current) inputRef.current.focus();

      focus.consume();
    }
  }, [focus]);

  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <FormGroup className={`ContractField-${name}`}>
      <LabeledBooleanCheckbox
        ref={inputRef}
        name={name}
        id={id}
        description={description as string}
        value={field.current || false}
        onChange={async (checked) => {
          field.onChange(checked);

          await field.onSave(checked);
        }}
        label={
          <span
            dangerouslySetInnerHTML={{
              __html: label || (schemaLabel as string),
            }}
          />
        }
        required={validation?.required}
      />
    </FormGroup>
  );
}
